// @ts-nocheck
/* eslint-disable */

import { fetchIntercomConfig } from './publicHead.api';

export const headIntercom = async () => {
  window.intercomSettings = await fetchIntercomConfig();

  var w = window;
  var ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', intercomSettings);
  } else {
    var d = document;
    var i = function() {
      i.c(arguments);
    };
    i.q = [];
    i.c = function(args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${intercomSettings.app_id}`;
    document.body.appendChild(s);
  }
};
